const STROKE = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
} as const;

/** 목록(전체 목차) */
export function ListIcon({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" aria-hidden="true">
      <path d="M2.5 4h11M2.5 8h11M2.5 12h11" {...STROKE} />
    </svg>
  );
}

/** 펼침 표시 — 목록이 단추 위로 펼쳐지므로 위를 가리키고, 펼친 단추(`aria-expanded="true"`)에서 스타일이 뒤집는다(`data-chevron`) */
export function ChevronIcon({ size = 12 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      aria-hidden="true"
      data-chevron=""
    >
      <path d="M2.5 7.5 6 4l3.5 3.5" {...STROKE} />
    </svg>
  );
}
